function useWindowSize() {
  const size = window.innerWidth;
  const isDesktop = size >= 992;
  const isMobile = !isDesktop;
  return {
    size,
    isMobile,
    isDesktop,
  };
}

export default useWindowSize;
